export default __webpack_public_path__ + "static/blob12-0ada9ec96d6c66b3b8fd428a6b5dbd8c.svg";